/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 17:31:00
 */

 import {Component} from 'vue-property-decorator'
 import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
 import override from "src/dectorators/override";
 import {AlarmListDOI} from "./api/alarmListApi";
 import AlarmListService from "./service/alarmListService";
 import './alarmList.less';
 
 @Component({name: 'alarm-list'})
 export default class AlarmList extends BasicSearchPage<AlarmListService, AlarmListDOI.RowDataI, AlarmListDOI.QueryRowDataParamsI> {
 
     @override
     renderHead(h) {
         return <div></div>
     }
     
     @override
     loadService () {
         this.service = new AlarmListService(this)
     }
 }